import { Cell } from '../../components'
import UserLink from './UserLink'
import {
  niceIso8601Time,
  withRouter,
} from '../../shared'

const ItemReportCell = ({ report }) =>
  <Cell cellClassName={report.reviewed ? 'dark' : ''}>
    <Cell.Body>
      <Cell.Line>
        <div>{report.reason} ({report.count})</div>
        <UserLink user_id={report.user_id} />
        <div>{niceIso8601Time(report.latest_created_date)}</div>
      </Cell.Line>
      <Cell.Line>
        <div>{report.description}</div>
      </Cell.Line>
    </Cell.Body>
  </Cell>

export default withRouter(ItemReportCell)
